import { render, staticRenderFns } from "./PickupPointList.vue?vue&type=template&id=3d236fb4&"
import script from "./PickupPointList.vue?vue&type=script&lang=js&"
export * from "./PickupPointList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports